<template>
	<div class="phone-country">
		<span v-if="selectedCountry" class="phone-country-selected" :class="{'active': phoneAutocomplete}">
			<input type="button" :id="field?.name + '_country'" :name="field?.name + '_country'" @blur="onBlurPhone" />
			<label :for="field?.name + '_country'" @click="onFocusPhone">
				<span class="img"><img width="24" height="16" :src="'/images/flags/' + selectedCountry?.code + '.svg'" alt="test" /></span>
				<span class="num">+{{ selectedCountry?.key.slice(2) }}</span>
			</label>
		</span>
		<ul v-if="phoneAutocomplete" class="phone-country-autocomplete">
			<li v-for="option in field?.options_prefix" :key="option.key" @click="selectCountry(option)">
				<span class="img"><img width="24" height="16" :src="'/images/flags/' + option.code + '.svg'" :alt="option.title" /></span>
				<span class="num">+{{ option.key.slice(2) }}</span>
				<span class="title">{{ option.title }}</span>
			</li>
		</ul>
	</div>
	<div class="phone-extra">
		<input type="tel" :id="field?.name + '_extra'" :name="field?.name + '_extra'" v-model="extraValue" @input="onInput" />
		<label v-show="!extraValue" :for="field?.name + '_extra'" class="sample"><BaseCmsLabel code="phone_example" /></label>
	</div>
</template>

<script setup>
	const config = useAppConfig();
	const props = defineProps(['field', 'input']);
	const emit = defineEmits(['selectCountryValue', 'phoneValueInput']);
	const extraValue = ref('');

	//selected
	const selectedCountry = ref(null);
	onMounted(() => {
		const selectedOption = props.field?.options_prefix.find(prefix => props.field?.value?.startsWith(prefix.key));
		if (selectedOption) {
			extraValue.value = props.field?.value?.replace(selectedOption?.key, '');
			selectedCountry.value = selectedOption;
		} else {
			selectedCountry.value = props.field?.options_prefix.find(option => option.code === "si");
		}
	})

	watch(
		() => props.input,
		() => {
			const selectedOption = props.field?.options_prefix.find(item => item.code == 'si');
			if (selectedOption) {
				extraValue.value = '';
				selectedCountry.value = selectedOption;
			}
		}
	)

	//select country
	function selectCountry(value) {
		selectedCountry.value = value;
		phoneAutocomplete.value = false;

		const combinedValue = `${selectedCountry.value.key}${extraValue.value}`;
		if(combinedValue) {
			emit('selectCountryValue', combinedValue);
		}
	}

	//send value
	function onInput(event) {
		let value = event.target.value;
		// Remove the leading '0' from the input value
		if (value.length > 4 && value.startsWith('0')) {
			extraValue.value = value.replace(/^0/, '');
		}

		const combinedValue = `${selectedCountry.value.key}${extraValue.value}`;
		if(combinedValue) {
			emit('phoneValueInput', combinedValue);
		}
	}

	//phone autocomplete
	const phoneAutocomplete = ref(false);

	function onFocusPhone() {
		phoneAutocomplete.value = !phoneAutocomplete.value;
		if(phoneAutocomplete.value == false) {
			onBlurPhone();
		}
	}

	function onBlurPhone() {
		if(phoneAutocomplete.value == true) {
			setTimeout(() => {
				phoneAutocomplete.value = false;
			},200);
		}
	}
</script>

<style lang="less" scoped>
	.phone-country{
		display: block; width: 90px; height: 54px; font-size: 15px; line-height: 1; position: absolute; left: 0; top: 0; left: 20px; z-index: 11;
		.img{display: flex; margin-right: 6px;}
		img{display: block; width: 24px; height: 16px; max-height: 100%;}

		@media (max-width: @m){left: 15px;}
	}
	.phone-country-selected{
		display: flex; align-items: center; margin-top: 28px; position: relative; cursor: pointer;
		input{width: 0; height: 0; padding: 0!important; border: none; cursor: pointer;}
		label{
			display: flex; align-items: center; flex-grow: 1; font-size: 15px!important; color: @textColor!important; line-height: 1; top: unset!important; left: unset!important; position: relative!important; cursor: pointer;
			&:before{.icon-arrow-down(); font: 9px/1 @fonti; color: @blue; position: absolute; top: 5px; right: 10px;}
		}
		&.active label:before{.rotate(180deg);}
	}
	.phone-country-autocomplete{
		display: block; overflow: auto; min-width: 150px; max-height: 250px; background: @white; box-shadow: 0 5px 20px 0 rgb(0 0 0 / 15%); font-size: 15px; position: absolute; top: 52px; left: -20px; z-index: 11111;
		&::-webkit-scrollbar {-webkit-appearance: none;width: 4px; background: #E0E8EE;}
		&::-webkit-scrollbar-thumb {border-radius: 0;background-color: #99AAB8;-webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);}
		&::-webkit-scrollbar-track {border: 1px solid #E0E8EE;}
		li{
			display: flex; align-items: center; padding: 6px 20px; white-space: nowrap; border-bottom: 1px solid @borderColor; cursor: pointer; .transition(all);
			.img{display: flex; margin-right: 6px;}
			.num{min-width: 35px; margin-right: 6px;}
			&:last-child{border-bottom: none;}
			&:hover, &.active{background: @secondaryColor; color: #fff;}
		}

		@media (max-width: @l){left: -15px;}
	}
	.phone-extra{
		input:focus + .sample{opacity: 0; font-size: 12px;}
		.sample{
			font-size: 16px!important; color: @inputTextColor; position: absolute; top: 24px!important; left: 111px; .transition(opacity);
		}
	}
</style>
